export default {
  props: ['visibleDrawer', 'projectModule'],
  data() {
    return {
      visible: true,
      title: null,
      list: { taxList: [], assetList: [] },
    }
  },
  watch: {
    'visibleDrawer'() {
      this.visible = this.visibleDrawer
    },
  },
  methods: {
    displayDrawer(title, key) {
      this.title = title
      this.visible = false
      this.$emit('hideSideBar', false)
      this.$root.$emit('openSidebar', true, title, key)
    },
  },
}
